import { render, staticRenderFns } from "./lineOscillogram.vue?vue&type=template&id=1a388122&scoped=true&"
import script from "./lineOscillogram.vue?vue&type=script&lang=js&"
export * from "./lineOscillogram.vue?vue&type=script&lang=js&"
import style0 from "./lineOscillogram.vue?vue&type=style&index=0&id=1a388122&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a388122",
  null
  
)

export default component.exports